(() => {
  const state = window.voicskyMarketVisibility;
  if (!state || state.enabled) return;
  const selector = 'a[href*="/products/apex-75-reiko-edition"],a[href*="/pages/pre-order-apex-75-reiko-edition"]';
  const cards = '.product-grid__item,.predictive-search-results__card';
  const updateCounts = (results) => {
    const hidden = results.querySelectorAll('.product-grid__item[data-voicsky-my-only]').length;
    if (!hidden) return;
    const source = results.querySelector('[data-results-count]');
    let total = Number(source?.dataset.resultsCount);
    if (!Number.isFinite(total)) total = results.querySelectorAll('.product-grid__item').length;
    const count = Math.max(0, total - hidden);
    results.querySelectorAll('.products-count-wrapper [role="status"]').forEach((node) => {
      const text = count === 1 ? state.itemOne : state.itemOther.replace('0', String(count));
      if (node.textContent.trim() !== text) node.textContent = text;
    });
    if (count === 0 && !results.querySelector('[data-voicsky-region-empty]')) {
      const grid = results.querySelector('#ResultsList');
      if (!grid) return;
      const empty = document.createElement('div');
      empty.className = 'main-collection-grid__empty';
      empty.dataset.voicskyRegionEmpty = '';
      const heading = document.createElement('h2');
      heading.className = 'main-collection-grid__empty-title h2';
      heading.textContent = state.empty;
      empty.append(heading);
      grid.prepend(empty);
    }
  };
  const filter = (root) => {
    const links = [...root.querySelectorAll(selector)];
    if (root.matches?.(selector)) links.push(root);
    const results = new Set();
    for (const link of links) {
      const card = link.closest(cards) || link.closest('.vkl__model,.voicsky-liquid-row__card,.voicsky-highlights__card,.voicsky-liquid-slideshow__slide,.voicsky-mega-panel__tile,product-card,.resource-card,.menu-list__list-item,.voicsky-mega-panel__group li,.voicsky-mobile-drawer-menu li') || link;
      card.dataset.voicskyMyOnly = '';
      card.hidden = true;
      const list = card.closest('results-list');
      if (list) results.add(list);
    }
    results.forEach(updateCounts);
  };
  filter(document);
  new MutationObserver((records) => {
    for (const record of records) {
      for (const node of record.addedNodes) {
        if (node.nodeType === 1) filter(node);
      }
    }
  }).observe(document.body, { childList: true, subtree: true });
})();
